import { useForm } from "react-hook-form";
import { useDataFetch } from "../../../../hooks/useDataFetch2";
import { useColumns } from "../utils/columns";
import { Suspense, useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../../../components/ui/materialui/breadcrumb";
import { Box, Grid2, Paper } from "@mui/material";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import InputSwitch from "../../../../components/inputs/yup/materialui/inputSwitch";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import TableHeader from "../../../../components/ui/materialui/tableHeader";
import Tabla from "../../../../components/ui/materialui/serverSideTable";
import { exportExcel } from "../../../../utils/exportExcel";
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import { Create, FilterList } from "@mui/icons-material";
import { PolizaEditar, UpdatePoliza } from "../models/polizaSeguro";
import CreateEditPoliza from "../components/createEditPoliza";
import { set } from "date-fns";
import { PermissionGuard } from "../../../../components/auth/ProtectedRoute";
import { TipoFuncionalidad } from "../../../../utils/enums";


interface IProps {
  estado: boolean;
}

function PolizaSeguro() {

  const [modalDetalle, setModalDetalle] = useState<boolean>(false)
  const [polizaEditar, setPolizaEditar] = useState<UpdatePoliza>()
  const [mostrarCreateEdit, setMostrarCreateEdit] = useState(false);
  const [isEditar, setIsEditar] = useState(false);
  const [searchFilter, setSearchFilter] = useState<string | null>(null);


  const urlTabla = `siscred-api-maestros/v1/polizaseguro/listar`;

  const controlTabla = useDataFetch(
    urlTabla,
    new URLSearchParams('filters.status=Activo'),
    true,
  )

  const {
    formState: { errors },
    control,
    handleSubmit,
    setValue,
    reset,
    watch
  } = useForm<IProps>({
    mode: "onBlur",
    defaultValues: {
      estado: true,
    },
  });
  const dataForm = watch();

  const handleCreateEditButtonClick = () => {
    setMostrarCreateEdit(true);
  };

  const { COLUMNS } = useColumns({
    controlTabla,
    handleCreateEditButtonClick,
    setIsEditar,
    setPolizaEditar,
    setModalDetalle
  });

  const columns = useMemo(() => COLUMNS, [controlTabla]);


  const breadcrumbItems = [
    { label: 'Inicio', url: '/' },
    { label: 'Maestros', url: `/maestros` },
    { label: 'Pólizas de seguros', active: true },
  ]

  const onSubmit = (data: IProps) => {
    controlTabla.manejarCambiosFiltros('filters.activo', data.estado ? 'Y' : 'N');
    controlTabla.fetchData();
  };

  const handleVolver = () => {
    setMostrarCreateEdit(false);
    setPolizaEditar(undefined);
    setIsEditar(false);
  };

  useEffect(() => {
  if (!searchFilter || searchFilter.trim() === "") {
    controlTabla.manejarCambiosFiltros("filters.search", "");
    controlTabla.fetchData();
  }
}, [searchFilter]);


  return (
    <>
      <Suspense>
        <Breadcrumb items={breadcrumbItems} />
        <Box sx={{ mt: 2 }}>
          <Paper elevation={3} sx={{ p: 3 }}>
            <Suspense>
              {mostrarCreateEdit ? (
                <CreateEditPoliza
                  codigoPoliza={polizaEditar?.codigo}
                  onVolver={handleVolver}
                  polizaEditar={polizaEditar}
                  isEdit={isEditar}
                  refresh={() => controlTabla.fetchData()}
                />
              ) : (
                <>
                  <CustomAccordion title="Filtros" expandedDefault>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <Grid2 container spacing={2}>
                        <Grid2 size={3}>
                          <InputSwitch
                            name="estado"
                            control={control}
                            label="Activo"
                          />
                        </Grid2>
                        <Grid2
                          size={3}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                          }}
                        >
                          <MButton
                            type="submit"
                            variant="contained"
                            color="primary"
                            startIcon={<FilterList />}
                          >
                            Filtrar
                          </MButton>
                        </Grid2>
                      </Grid2>
                    </form>
                  </CustomAccordion>

                  <Tabla
                    url={urlTabla}
                    columns={columns}
                    control={controlTabla}
                    callApi={false}
                    titulo={
                      <TableHeader
                        title=""
                        control={controlTabla}
                        searchFilter={searchFilter}
                        hideSearchFilter={false}
                        button={
                          <PermissionGuard permissions={[TipoFuncionalidad.Maestros_editar]}>
                          <MButton
                            type="button"
                            variant="contained"
                            onClick={() => {
                              setModalDetalle(true);
                              setPolizaEditar(undefined);
                              setMostrarCreateEdit(true);
                              setIsEditar(false);
                            }}
                            startIcon={<AddTwoToneIcon />}
                          >
                            Nueva
                          </MButton>
                          </PermissionGuard>
                        }
                        buttonExport={
                          <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                          <MButton
                            type="button"
                            variant="outlined"
                            onClick={() =>
                              exportExcel(
                                controlTabla.data,
                                columns,
                                "Pólizas de seguros"
                              )
                            }
                            startIcon={<SummarizeTwoToneIcon />}
                          >
                            Exportar
                          </MButton>
                          </PermissionGuard>
                        }
                      />
                    }
                  />
                </>
              )}
            </Suspense>
          </Paper>
        </Box>
      </Suspense>
    </>
  );
}

export default PolizaSeguro;
